import { z } from 'zod';

import { AB_TEST_STATUS } from '@@api/services/abTests/schemas';
import ContentStatus from '@@constants/ContentStatus';
import PublicationStatus from '@@constants/PublicationStatus';

import { SEARCH_TYPE, SIMILARITY } from './types';

/**
 * The search fields of the lists: their filters, their page and their sort. A list's schema picks
 * the ones it uses, never more.
 *
 * @example
 * validateSearch: unitySearchParams.pick({ q: true, page: true }),
 */
export const unitySearchParams = z.object({
    q: z.string().optional().catch(undefined),
    page: z.number().int().positive().optional().catch(undefined),
    // The API's value, such as `updatedAt,desc`
    sort: z.string().optional().catch(undefined),
    statuses: z.array(z.enum(AB_TEST_STATUS)).optional().catch(undefined),
    tenantIds: z.array(z.number()).optional().catch(undefined),
    userIds: z.string().optional().catch(undefined),
    contentType: z.string().optional().catch(undefined),
    publicationStatus: z.array(z.enum(PublicationStatus)).optional().catch(undefined),
    contentStatus: z.array(z.enum(ContentStatus)).optional().catch(undefined),
    leagueIds: z.array(z.number()).optional().catch(undefined),
    categoryIds: z.array(z.number()).optional().catch(undefined),
    tagIds: z.array(z.number()).optional().catch(undefined),
    type: z.string().optional().catch(undefined),
    publishedBefore: z.string().optional().catch(undefined),
    publishedAfter: z.string().optional().catch(undefined),
    searchType: z.enum(SEARCH_TYPE).optional().catch(undefined),
    semanticQ: z.string().optional().catch(undefined),
    kSimilarity: z.literal(Object.values(SIMILARITY)).optional().catch(undefined),
});

/** Every value a list search can hold */
export type UnitySearchParams = z.output<typeof unitySearchParams>;

/** The search of the lists that filter by text only */
export const textSearchParams = unitySearchParams.pick({ q: true });
